import { Component, OnInit } from '@angular/core';

@Component({
  template: '',
  standalone: false
})
export class BasePaylineEditComponent implements OnInit {
  public navigationKeys = [
    'Enter',
    'NumpadEnter',
    'Tab',
    'ArrowUp',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight'
  ];

  constructor() {}

  ngOnInit(): void {}

  // attempt to allow user to keyboard navigate around
  // the payline detail editor similar to the payroll grid
  public onKeyboardNavigate(keyCode: string, row: number, column: number, lastRowIndex: number) {
    let direction: 'up' | 'down' | 'left' | 'right';
    if (keyCode == 'ArrowLeft') {
      direction = 'left';
    } else if (keyCode == 'ArrowRight') {
      direction = 'right';
    } else if (keyCode == 'ArrowUp') {
      direction = 'up';
    } else if (['ArrowDown', 'NumpadEnter', 'Enter'].includes(keyCode)) {
      direction = 'down';
    }

    // this is where the fun begins...
    // inputs that are disabled cannot be focused.
    // each section (earnings, deductions, etc) has
    // a varying amount of rows.
    // run a loop to try to find the next available input
    // if we hit the start/end of any row/column - stop there
    let next = this._stepToNextInput(direction, row, column);
    row = next.row;
    column = next.column;

    let nextInput = document.getElementById(`column-${column}-row-${row}`);

    while (!nextInput || nextInput.attributes.getNamedItem('disabled')?.value == 'disabled') {
      next = this._stepToNextInput(direction, row, column);

      row = next.row;
      column = next.column;

      // if we've hit the start or end, stop looking for an available input
      // NOTE: there are currently up to 5 focusable columns
      if (column < 0 || column > 5 || row < 0 || row > lastRowIndex) {
        break;
      }

      nextInput = document.getElementById(`column-${column}-row-${row}`);
    }

    if (nextInput) {
      nextInput.focus();
    }
  }

  private _stepToNextInput(
    direction: 'up' | 'down' | 'left' | 'right',
    row: number,
    column: number
  ) {
    if (direction === 'left') {
      column--;
    } else if (direction === 'right') {
      column++;
    } else if (direction === 'up') {
      row--;
    } else if (direction === 'down') {
      row++;
    }

    return { row, column };
  }
}
